<template>
  <div>
    <!-- {{ this.selectedCake }}
    {{ checked }}
    {{ this.date }} -->
    <div style="display: none;">{{ checked }}</div>
    <!-- {{ kb }} {{ week }}
    {{ value2 }} -->
    <!-- {{ value2_km }}
    {{ value2_kw }}
    {{ value2_rm }}
    {{ value2_rw }} -->
    <!-- {{ date_min_max }} -->

    <!-- {{ YmdList2 }} -->
    <!-- {{ value2 }}
    {{ kb }} {{ week }}
    {{ YmdList2 }} -->
    <!-- {{ value2 }}
    {{ sdate }}
    {{ mdate }}
    {{ edate }}
    {{ YmdList2 }} -->

      <div v-if="isLoading" class="loading-container">
        <div class="loading">
          <FadeLoader />
        </div>
      </div> 

    <div class="row mt-1 g-md-0">
        <div v-if="kb === 'r1'" class="col-md-2 bg-light" style="position:fixed;height: 100%;">
            <div class="alert alert-secondary ms-1 mb-1 pt-2 pb-2 text-start" role="alert">
            <b>지역단일선택</b>
            </div>
            
            

          
            <!-- <div class="btn-group btn-group-sm me-2" role="group" aria-label="Basic radio toggle button group">
              <input type="radio" class="btn-check" name="btnradio5" id="btnradio5" autocomplete="off" checked>
              <label class="btn btn-outline-primary" for="btnradio5">매매</label>
              <input type="radio" class="btn-check" name="btnradio5" id="btnradio6" autocomplete="off">
              <label class="btn btn-outline-primary" for="btnradio6">전세</label>
            </div> -->
          
            <!-- <div class="btn-group btn-group-sm me-2" role="group" aria-label="Basic radio toggle button group">
              <input type="radio" class="btn-check" name="btnradio_" id="btnradio_1" autocomplete="off" checked>
              <label class="btn btn-outline-primary" for="btnradio_1">1M</label>
    
              <input type="radio" class="btn-check" name="btnradio_" id="btnradio_3" autocomplete="off" checked>
              <label class="btn btn-outline-primary" for="btnradio_3">3M</label>
          
              <input type="radio" class="btn-check" name="btnradio_" id="btnradio_6" autocomplete="off" checked>
              <label class="btn btn-outline-primary" for="btnradio_6">6M</label>
          
              <input type="radio" class="btn-check" name="btnradio_" id="btnradio_12" autocomplete="off" checked>
              <label class="btn btn-outline-primary" for="btnradio_12">1Y</label>
            </div> -->






            <treeselect class="mt-0 ms-1" v-model="selectedCake" :value="value" :multiple="false" :options="optionsR1" :flat="true" :always-open="true" :show-count="true" :value-consists-of="valueConsistsOf" clearAllText="모두 삭제" :sort-value-by="sortValueBy" :max-height="600"/><treeselect-value :value="value" />
        </div>
        <div v-else-if="kb === 'kb'" class="col-md-2 bg-light" style="position:fixed;height: 100%;">
            <div class="alert alert-secondary ms-1 mb-1 pt-2 pb-2 text-start" role="alert">
            <b>지역단일선택</b>
            </div>                
            <treeselect class="mt-0 ms-1" v-model="selectedCake" :value="value" :multiple="false" :options="optionsKb" :flat="true" :always-open="true" :show-count="true" :value-consists-of="valueConsistsOf" clearAllText="모두 삭제" :sort-value-by="sortValueBy" :max-height="600"/><treeselect-value :value="value" />
        </div>  
    </div>
 
  <div class="col-md-10 offset-md-2">

    <div class="text-start ms-2 mr-2 mb-1">

      <div class="btn-group btn-group-sm me-2" role="group" aria-label="Basic radio toggle button group">
          <input @click="change_kb('kb')" type="radio" class="btn-check" name="kb" id="btnradio1" autocomplete="off">
          <label class="btn btn-outline-primary" for="btnradio1">KB부동산</label>
    
          <input @click="change_kb('r1')" type="radio" class="btn-check" name="kb" id="btnradio2" autocomplete="off" checked>
          <label class="btn btn-outline-primary" for="btnradio2">한국부동산원</label>
      </div>
    
      <div class="btn-group btn-group-sm me-2" role="group" aria-label="Basic radio toggle button group">
          <input @click="change_week('mon')" type="radio" class="btn-check" name="week" id="btnradio3" autocomplete="off">
          <label class="btn btn-outline-primary" for="btnradio3">월간</label>
    
          <input @click="change_week('week')" type="radio" class="btn-check" name="week" id="btnradio4" autocomplete="off" checked>
          <label class="btn btn-outline-primary" for="btnradio4">주간</label>
      </div>

      <!-- <div class="btn-group btn-group-sm me-2" role="group" aria-label="Basic radio toggle button group">

        <input type="radio" class="btn-check" name="btnradio5" id="btnradio5" autocomplete="off" checked>
        <label class="btn btn-outline-primary" for="btnradio5">매매</label>

        <input type="radio" class="btn-check" name="btnradio5" id="btnradio6" autocomplete="off">
        <label class="btn btn-outline-primary" for="btnradio6">전세</label>

        <input type="radio" class="btn-check" name="btnradio5" id="btnradio9" autocomplete="off">
        <label class="btn btn-outline-primary" for="btnradio9">매매+전세</label>   

        <input type="radio" class="btn-check" name="btnradio5" id="btnradio7" autocomplete="off">
        <label class="btn btn-outline-primary" for="btnradio7">매매지수+전세지수</label>

        <input type="radio" class="btn-check" name="btnradio5" id="btnradio8" autocomplete="off">
        <label class="btn btn-outline-primary" for="btnradio8">매매증감+전세증감</label>        

     
      </div> -->

    </div>




      <div id="chart" class="border ms-2 mr-2">
        <apexchart height="500" :options="chartOptions" :series="series"></apexchart>
        <div>
          <!-- <h4>기간설정</h4> -->
          <div>기간: {{ value2[0] }} ~ {{ value2[1] }}</div>
          <Vue3Slider class="ms-3 mr-5" :data="YmdList2" :enableCross="enableCross" v-model="value2" :adsorb="true" :order="order" :lazy="true" :height="15" />
        </div>        
      </div>




  </div>

  </div>  
</template>

<script>
// import the component
import Treeselect from 'vue3-treeselect'
// import the styles
import 'vue3-treeselect/dist/vue3-treeselect.css'

import VueApexCharts from "vue3-apexcharts";

// import { ref } from 'vue';
import Vue3Slider from 'vue-3-slider-component';

import FadeLoader from 'vue-spinner/src/FadeLoader.vue'
import cloneDeep from 'lodash.clonedeep'

export default {
   
  components: {
    FadeLoader,
    Treeselect,
    apexchart: VueApexCharts,
    Vue3Slider
  },
  // setup() {
  //   let value1 = ref(50)
  //   let value2 = ref(["2012-05-07", "2023-02-20"])
  //   let value3 = ref(0.5)
  //   let value4 = ref(5)
  //   let value5 = ref(5)
  //   return { value1, value2, value3, value4, value5 }
  // },
  computed: {
    checked() {
      // this.getYmdList2(this.kb,this.week);   
      let aaa=Number(this.selectedCake)
      let kb = this.kb
      let week = this.week
      let value2 = cloneDeep(this.value2)


      // this.getYmdList2(kb,week,aaa)
      console.log(kb,week,value2[0],value2[1])
      this.getR1WeekList(kb,week,aaa,value2[0],value2[1]);
      return Number(aaa)
    },      
  },  
  mounted() {
      
  },
  created() {
    this.getSidoList();
    this.getSigunList();
    this.date_period(this.selectedCake)
    // this.getYmdList2(this.kb,this.week,this.selectedCake);    
    this.getR1WeekList(this.kb,this.week,this.selectedCake,"2021-01-18", "2023-02-20" );

  },  
  data() {
    return{
      R1WeekList:[],
      selectedCake: 48170, 

      enableCross: false,
      order: true,

      YmdList2: [],
      sdate:'',
      mdate:'',
      edate:'',

      sigun: '',
      date:[],

      value2:["2021-01-18", "2023-02-20" ],
      // value2:["2021-01-01", "2023-01-01" ],
      value2_rw:[],
      value2_rm:[],
      value2_kw:[],
      value2_km:[],
      date_min_max:{
        'kb_week':{'min':'2021-01-18','max':'2023-02-20'},
        'kb_mon':{'min':'2021-01-01','max':'2023-01-01'},
        'r1_week':{'min':'2021-01-18','max':'2023-02-20'},
        'r1_mon':{'min':'2021-01-01','max':'2023-01-01'},
      },

      series: [{
        name: '매매지수',
        type: 'line',
        data: []
      }, {
        name: '매매증감',
        type: 'column',
        data: []
      },{
        name: '전세지수',
        type: 'line',
        data: []
      }, {
        name: '전세증감',
        type: 'column',
        data: []
      }],
      chartOptions: {
        chart: {
          height: 350,
          type: 'line',
        },
        stroke: {
          width: [0, 3]
        },
        title: {
          text: `${this.sigun}`
        },
        dataLabels: {
          // enabled: true,
          // enabledOnSeries: [1]
        },
        labels: [],
        xaxis: {
          type: 'datetime',
          categories:[],
        },
        yaxis: [{
          title: {
            text: '매매증감',
          },
        
        }, {
          opposite: true,
          title: {
            text: '매매지수'
          },
          min: 60
        }]
      },


      isLoading: false,

      //treeselect
      value: null,

      optionsR1: [{'id': 11000, 'label': '서울특별시', 'children': [{'id': 11110, 'label': '종로구'}, {'id': 11140, 'label': '중구'}, {'id': 11170, 'label': '용산구'}, {'id': 11200, 'label': '성동구'}, {'id': 11215, 'label': '광진구'}, {'id': 11230, 'label': '동대문구'}, {'id': 11260, 'label': '중랑구'}, {'id': 11290, 'label': '성북구'}, {'id': 11305, 'label': '강북구'}, {'id': 11320, 'label': '도봉구'}, {'id': 11350, 'label': '노원구'}, {'id': 11380, 'label': '은평구'}, {'id': 11410, 'label': '서대문구'}, {'id': 11440, 'label': '마포구'}, {'id': 11470, 'label': '양천구'}, {'id': 11500, 'label': '강서구'}, {'id': 11530, 'label': '구로구'}, {'id': 11545, 'label': '금천구'}, {'id': 11560, 'label': '영등포구'}, {'id': 11590, 'label': '동작구'}, {'id': 11620, 'label': '관악구'}, {'id': 11650, 'label': '서초구'}, {'id': 11680, 'label': '강남구'}, {'id': 11710, 'label': '송파구'}, {'id': 11740, 'label': '강동구'}]}, {'id': 41000, 'label': '경기도', 'children': [{'id': 41290, 'label': '과천시'}, {'id': 41171, 'label': '안양시 만안구'}, {'id': 41173, 'label': '안양시 동안구'}, {'id': 41131, 'label': '성남시 수정구'}, {'id': 41133, 'label': '성남시 중원구'}, {'id': 41135, 'label': '성남시 분당구'}, {'id': 41410, 'label': '군포시'}, {'id': 41430, 'label': '의왕시'}, {'id': 41550, 'label': '안성시'}, {'id': 41461, 'label': '용인시 처인구'}, {'id': 41463, 'label': '용인시 기흥구'}, {'id': 41465, 'label': '용인시 수지구'}, {'id': 41111, 'label': '수원시 장안구'}, {'id': 41113, 'label': '수원시 권선구'}, {'id': 41115, 'label': '수원시 팔달구'}, {'id': 41117, 'label': '수원시 영통구'}, {'id': 41190, 'label': '부천시'}, {'id': 41271, 'label': '안산시 상록구'}, {'id': 41273, 'label': '안산시 단원구'}, {'id': 41390, 'label': '시흥시'}, {'id': 41210, 'label': '광명시'}, {'id': 41590, 'label': '화성시'}, {'id': 41370, 'label': '오산시'}, {'id': 41220, 'label': '평택시'}, {'id': 41360, 'label': '남양주시'}, {'id': 41310, 'label': '구리시'}, {'id': 41450, 'label': '하남시'}, {'id': 41610, 'label': '광주시'}, {'id': 41500, 'label': '이천시'}, {'id': 41670, 'label': '여주시'}, {'id': 41570, 'label': '김포시'}, {'id': 41281, 'label': '고양시 덕양구'}, {'id': 41285, 'label': '고양시 일산동구'}, {'id': 41287, 'label': '고양시 일산서구'}, {'id': 41480, 'label': '파주시'}, {'id': 41650, 'label': '포천시'}, {'id': 41250, 'label': '동두천시'}, {'id': 41630, 'label': '양주시'}, {'id': 41150, 'label': '의정부시'}]}, {'id': 28000, 'label': '인천광역시', 'children': [{'id': 28110, 'label': '중구'}, {'id': 28140, 'label': '동구'}, {'id': 28177, 'label': '미추홀구'}, {'id': 28185, 'label': '연수구'}, {'id': 28200, 'label': '남동구'}, {'id': 28237, 'label': '부평구'}, {'id': 28245, 'label': '계양구'}, {'id': 28260, 'label': '서구'}]}, {'id': 26000, 'label': '부산광역시', 'children': [{'id': 26110, 'label': '중구'}, {'id': 26140, 'label': '서구'}, {'id': 26170, 'label': '동구'}, {'id': 26200, 'label': '영도구'}, {'id': 26230, 'label': '부산진구'}, {'id': 26290, 'label': '남구'}, {'id': 26470, 'label': '연제구'}, {'id': 26500, 'label': '수영구'}, {'id': 26350, 'label': '해운대구'}, {'id': 26410, 'label': '금정구'}, {'id': 26260, 'label': '동래구'}, {'id': 26710, 'label': '기장군'}, {'id': 26320, 'label': '북구'}, {'id': 26440, 'label': '강서구'}, {'id': 26530, 'label': '사상구'}, {'id': 26380, 'label': '사하구'}]}, {'id': 27000, 'label': '대구광역시', 'children': [{'id': 27110, 'label': '중구'}, {'id': 27140, 'label': '동구'}, {'id': 27170, 'label': '서구'}, {'id': 27200, 'label': '남구'}, {'id': 27230, 'label': '북구'}, {'id': 27260, 'label': '수성구'}, {'id': 27290, 'label': '달서구'}, {'id': 27710, 'label': '달성군'}]}, {'id': 29000, 'label': '광주광역시', 'children': [{'id': 29110, 'label': '동구'}, {'id': 29140, 'label': '서구'}, {'id': 29155, 'label': '남구'}, {'id': 29170, 'label': '북구'}, {'id': 29200, 'label': '광산구'}]}, {'id': 30000, 'label': '대전광역시', 'children': [{'id': 30110, 'label': '동구'}, {'id': 30140, 'label': '중구'}, {'id': 30170, 'label': '서구'}, {'id': 30200, 'label': '유성구'}, {'id': 30230, 'label': '대덕구'}]}, {'id': 31000, 'label': '울산광역시', 'children': [{'id': 31110, 'label': '중구'}, {'id': 31140, 'label': '남구'}, {'id': 31170, 'label': '동구'}, {'id': 31200, 'label': '북구'}, {'id': 31710, 'label': '울주군'}]}, {'id': 36110, 'label': '세종특별자치시', 'children': [{'id': 36110, 'label': '세종시'}]}, {'id': 42000, 'label': '강원도', 'children': [{'id': 42110, 'label': '춘천시'}, {'id': 42130, 'label': '원주시'}, {'id': 42150, 'label': '강릉시'}, {'id': 42170, 'label': '동해시'}, {'id': 42190, 'label': '태백시'}, {'id': 42210, 'label': '속초시'}, {'id': 42230, 'label': '삼척시'}]}, {'id': 43000, 'label': '충청북도', 'children': [{'id': 43111, 'label': '청주시 상당구'}, {'id': 43112, 'label': '청주시 서원구'}, {'id': 43113, 'label': '청주시 흥덕구'}, {'id': 43114, 'label': '청주시 청원구'}, {'id': 43130, 'label': '충주시'}, {'id': 43150, 'label': '제천시'}, {'id': 43770, 'label': '음성군'}]}, {'id': 44000, 'label': '충청남도', 'children': [{'id': 44131, 'label': '천안시 동남구'}, {'id': 44133, 'label': '천안시 서북구'}, {'id': 44150, 'label': '공주시'}, {'id': 44180, 'label': '보령시'}, {'id': 44200, 'label': '아산시'}, {'id': 44210, 'label': '서산시'}, {'id': 44230, 'label': '논산시'}, {'id': 44250, 'label': '계룡시'}, {'id': 44800, 'label': '홍성군'}, {'id': 44810, 'label': '예산군'}, {'id': 44270, 'label': '당진시'}]}, {'id': 45000, 'label': '전라북도', 'children': [{'id': 45111, 'label': '전주시 완산구'}, {'id': 45113, 'label': '전주시 덕진구'}, {'id': 45130, 'label': '군산시'}, {'id': 45140, 'label': '익산시'}, {'id': 45180, 'label': '정읍시'}, {'id': 45190, 'label': '남원시'}, {'id': 45210, 'label': '김제시'}]}, {'id': 46000, 'label': '전라남도', 'children': [{'id': 46110, 'label': '목포시'}, {'id': 46130, 'label': '여수시'}, {'id': 46150, 'label': '순천시'}, {'id': 46170, 'label': '나주시'}, {'id': 46230, 'label': '광양시'}, {'id': 46840, 'label': '무안군'}]}, {'id': 47000, 'label': '경상북도', 'children': [{'id': 47130, 'label': '경주시'}, {'id': 47190, 'label': '구미시'}, {'id': 47111, 'label': '포항시 남구'}, {'id': 47113, 'label': '포항시 북구'}, {'id': 47150, 'label': '김천시'}, {'id': 47170, 'label': '안동시'}, {'id': 47210, 'label': '영주시'}, {'id': 47230, 'label': '영천시'}, {'id': 47250, 'label': '상주시'}, {'id': 47280, 'label': '문경시'}, {'id': 47290, 'label': '경산시'}, {'id': 47850, 'label': '칠곡군'}]}, {'id': 48000, 'label': '경상남도', 'children': [{'id': 48121, 'label': '창원시 의창구'}, {'id': 48123, 'label': '창원시 성산구'}, {'id': 48125, 'label': '창원시 마산합포구'}, {'id': 48127, 'label': '창원시 마산회원구'}, {'id': 48129, 'label': '창원시 진해구'}, {'id': 48170, 'label': '진주시'}, {'id': 48220, 'label': '통영시'}, {'id': 48240, 'label': '사천시'}, {'id': 48250, 'label': '김해시'}, {'id': 48270, 'label': '밀양시'}, {'id': 48310, 'label': '거제시'}, {'id': 48330, 'label': '양산시'}]}, {'id': 50000, 'label': '제주특별자치도', 'children': [{'id': 50110, 'label': '제주시'}, {'id': 50130, 'label': '서귀포시'}]}],
      
      optionsKb: [{'id': 11000, 'label': '서울특별시', 'children': [{'id': 11305, 'label': '강북구'}, {'id': 11215, 'label': '광진구'}, {'id': 11350, 'label': '노원구'}, {'id': 11320, 'label': '도봉구'}, {'id': 11230, 'label': '동대문구'}, {'id': 11440, 'label': '마포구'}, {'id': 11410, 'label': '서대문구'}, {'id': 11200, 'label': '성동구'}, {'id': 11290, 'label': '성북구'}, {'id': 11170, 'label': '용산구'}, {'id': 11380, 'label': '은평구'}, {'id': 11110, 'label': '종로구'}, {'id': 11140, 'label': '중구'}, {'id': 11260, 'label': '중랑구'}, {'id': 11680, 'label': '강남구'}, {'id': 11740, 'label': '강동구'}, {'id': 11500, 'label': '강서구'}, {'id': 11620, 'label': '관악구'}, {'id': 11530, 'label': '구로구'}, {'id': 11545, 'label': '금천구'}, {'id': 11590, 'label': '동작구'}, {'id': 11650, 'label': '서초구'}, {'id': 11710, 'label': '송파구'}, {'id': 11470, 'label': '양천구'}, {'id': 11560, 'label': '영등포구'}]},{'id': 41000, 'label': '경기도', 'children': [{'id': 41111, 'label': '수원시 장안구'}, {'id': 41113, 'label': '수원시 권선구'}, {'id': 41115, 'label': '수원시 팔달구'}, {'id': 41117, 'label': '수원시 영통구'}, {'id': 41131, 'label': '성남시 수정구'}, {'id': 41133, 'label': '성남시 중원구'}, {'id': 41135, 'label': '성남시 분당구'}, {'id': 41281, 'label': '고양시 덕양구'}, {'id': 41285, 'label': '고양시 일산동구'}, {'id': 41287, 'label': '고양시 일산서구'}, {'id': 41171, 'label': '안양시 만안구'}, {'id': 41173, 'label': '안양시 동안구'}, {'id': 41190, 'label': '부천시'}, {'id': 41150, 'label': '의정부시'}, {'id': 41210, 'label': '광명시'}, {'id': 41220, 'label': '평택시'}, {'id': 41273, 'label': '안산시 단원구'}, {'id': 41271, 'label': '안산시 상록구'}, {'id': 41290, 'label': '과천시'}, {'id': 41310, 'label': '구리시'}, {'id': 41360, 'label': '남양주시'}, {'id': 41461, 'label': '용인시 처인구'}, {'id': 41463, 'label': '용인시 기흥구'}, {'id': 41465, 'label': '용인시 수지구'}, {'id': 41390, 'label': '시흥시'}, {'id': 41410, 'label': '군포시'}, {'id': 41430, 'label': '의왕시'}, {'id': 41450, 'label': '하남시'}, {'id': 41370, 'label': '오산시'}, {'id': 41480, 'label': '파주시'}, {'id': 41500, 'label': '이천시'}, {'id': 41550, 'label': '안성시'}, {'id': 41570, 'label': '김포시'}, {'id': 41630, 'label': '양주시'}, {'id': 41250, 'label': '동두천시'}, {'id': 41610, 'label': '광주시'}, {'id': 41590, 'label': '화성시'}]},{'id': 28000, 'label': '인천광역시', 'children': [{'id': 28110, 'label': '중구'}, {'id': 28140, 'label': '동구'}, {'id': 28177, 'label': '미추홀구'}, {'id': 28185, 'label': '연수구'}, {'id': 28200, 'label': '남동구'}, {'id': 28237, 'label': '부평구'}, {'id': 28245, 'label': '계양구'}, {'id': 28260, 'label': '서구'}]}, {'id': 26000, 'label': '부산광역시', 'children': [{'id': 26110, 'label': '중구'}, {'id': 26140, 'label': '서구'}, {'id': 26170, 'label': '동구'}, {'id': 26200, 'label': '영도구'}, {'id': 26230, 'label': '부산진구'}, {'id': 26260, 'label': '동래구'}, {'id': 26290, 'label': '남구'}, {'id': 26320, 'label': '북구'}, {'id': 26350, 'label': '해운대구'}, {'id': 26380, 'label': '사하구'}, {'id': 26410, 'label': '금정구'}, {'id': 26470, 'label': '연제구'}, {'id': 26500, 'label': '수영구'}, {'id': 26530, 'label': '사상구'}, {'id': 26710, 'label': '기장군'}, {'id': 26440, 'label': '강서구'}]}, {'id': 27000, 'label': '대구광역시', 'children': [{'id': 27110, 'label': '중구'}, {'id': 27140, 'label': '동구'}, {'id': 27170, 'label': '서구'}, {'id': 27200, 'label': '남구'}, {'id': 27230, 'label': '북구'}, {'id': 27260, 'label': '수성구'}, {'id': 27290, 'label': '달서구'}, {'id': 27710, 'label': '달성군'}]},  {'id': 29000, 'label': '광주광역시', 'children': [{'id': 29110, 'label': '동구'}, {'id': 29140, 'label': '서구'}, {'id': 29155, 'label': '남구'}, {'id': 29170, 'label': '북구'}, {'id': 29200, 'label': '광산구'}]}, {'id': 30000, 'label': '대전광역시', 'children': [{'id': 30110, 'label': '동구'}, {'id': 30140, 'label': '중구'}, {'id': 30170, 'label': '서구'}, {'id': 30200, 'label': '유성구'}, {'id': 30230, 'label': '대덕구'}]}, {'id': 31000, 'label': '울산광역시', 'children': [{'id': 31110, 'label': '중구'}, {'id': 31140, 'label': '남구'}, {'id': 31170, 'label': '동구'}, {'id': 31200, 'label': '북구'}, {'id': 31710, 'label': '울주군'}]}, {'id': 36110, 'label': '세종특별자치시', 'children': [{'id': 36110, 'label': '세종시'}]},  {'id': 42000, 'label': '강원도', 'children': [{'id': 42110, 'label': '춘천시'}, {'id': 42150, 'label': '강릉시'}, {'id': 42130, 'label': '원주시'}]}, {'id': 43000, 'label': '충청북도', 'children': [{'id': 43111, 'label': '청주시 상당구'}, {'id': 43112, 'label': '청주시 서원구'}, {'id': 43114, 'label': '청주시 청원구'}, {'id': 43113, 'label': '청주시 흥덕구'}, {'id': 43130, 'label': '충주시'}, {'id': 43150, 'label': '제천시'}]}, {'id': 44000, 'label': '충청남도', 'children': [{'id': 44131, 'label': '천안시 동남구'}, {'id': 44133, 'label': '천안시 서북구'}, {'id': 44150, 'label': '공주시'}, {'id': 44200, 'label': '아산시'}, {'id': 44230, 'label': '논산시'}, {'id': 44250, 'label': '계룡시'}, {'id': 44270, 'label': '당진시'}, {'id': 44210, 'label': '서산시'}]}, {'id': 45000, 'label': '전라북도', 'children': [{'id': 45111, 'label': '전주시 완산구'}, {'id': 45113, 'label': '전주시 덕진구'}, {'id': 45140, 'label': '익산시'}, {'id': 45130, 'label': '군산시'}]}, {'id': 46000, 'label': '전라남도', 'children': [{'id': 46110, 'label': '목포시'}, {'id': 46150, 'label': '순천시'}, {'id': 46230, 'label': '광양시'}, {'id': 46130, 'label': '여수시'}]}, {'id': 47000, 'label': '경상북도', 'children': [{'id': 47111, 'label': '포항시 남구'}, {'id': 47113, 'label': '포항시 북구'}, {'id': 47190, 'label': '구미시'}, {'id': 47290, 'label': '경산시'}, {'id': 47170, 'label': '안동시'}, {'id': 47150, 'label': '김천시'}]}, {'id': 48000, 'label': '경상남도', 'children': [{'id': 48125, 'label': '창원시 마산합포구'}, {'id': 48127, 'label': '창원시 마산회원구'}, {'id': 48123, 'label': '창원시 성산구'}, {'id': 48121, 'label': '창원시 의창구'}, {'id': 48129, 'label': '창원시 진해구'}, {'id': 48330, 'label': '양산시'}, {'id': 48310, 'label': '거제시'}, {'id': 48170, 'label': '진주시'}, {'id': 48250, 'label': '김해시'}, {'id': 48220, 'label': '통영시'}]}, {'id': 50000, 'label': '제주특별자치도', 'children': [{'id': 50130, 'label': '서귀포시'}]}],       
      
      valueConsistsOf: 'LEAF_PRIORITY',
      sortValueBy: 'LEVEL',

      kb:'r1', //'r1'
      week:'week', //'mon'
      m_js:'m_js', //'j'


    };
  },
  methods: {

    async date_period(a) {
      let km = await this.$api("/api/YmdList2","post", { param: [`api_series_kb_mon`,a]});
      let kw = await this.$api("/api/YmdList2","post", { param: [`api_series_kb_week`,a]});
      let rm = await this.$api("/api/YmdList2","post", { param: [`api_series_r1_mon`,a]});
      let rw = await this.$api("/api/YmdList2","post", { param: [`api_series_r1_week`,a]});
      // console.log(kb_mon[kb_mon.length-1].ymd2)
      // console.log(kb_mon[kb_mon.length-25].ymd2)
      this.value2_km = [km[km.length-25].ymd2,km[km.length-1].ymd2]
      this.value2_kw = [kw[kw.length-105].ymd2,kw[kw.length-1].ymd2]
      this.value2_rm = [rm[rm.length-25].ymd2,rm[rm.length-1].ymd2]
      this.value2_rw = [rw[rw.length-105].ymd2,rw[rw.length-1].ymd2]

      let date_min_max={
        'kb_week':{'min':kw[kw.length-105].ymd2,'max':kw[kw.length-1].ymd2},
        'kb_mon':{'min':km[km.length-25].ymd2,'max':km[km.length-1].ymd2},
        'r1_week':{'min':rw[rw.length-105].ymd2,'max':rw[rw.length-1].ymd2},
        'r1_mon':{'min':rm[rm.length-25].ymd2,'max':rm[rm.length-1].ymd2},
      }

      this.date_min_max = date_min_max

    },
    async getYmdList2(kb,week,a) {
        // this.date_period(a);
        let YmdList2 = await this.$api("/api/YmdList2","post", { param: [`api_series_${kb}_${week}`,a]});
        let ymd = []
        for (let i = 0; i < YmdList2.length; i++) {
          ymd.push(YmdList2[i].ymd2)
        }
        this.YmdList2 = ymd;
        // this.sdate = ymd.slice(0)[0]
        // this.mdate = ymd.slice(-155)[0]
        // this.edate = ymd.slice(-1)[0]
        // this.value2 = [ymd.slice(-155)[0],ymd.slice(-1)[0]]
    },    
    async getR1WeekList(kb,week,a,b,c) {
      this.enableCross=true
      this.order=false
      this.getYmdList2(kb,week,a)
      let R1WeekList = await this.$api("/api/R1WeekList","post",{ param: [`api_series_${kb}_${week}`,a, b, c] })
      this.isLoading = true
      // let Ymd=[]
      let Ymd2=[]
      let m_js=[]
      let m_dt=[]
      let j_js=[]
      let j_dt=[]
      let sigun = R1WeekList[0].sigun 
      console.log(sigun)     
      for (let i = 0; i < R1WeekList.length; i++) {
        // Ymd.push(R1WeekList[i].ymd)
        Ymd2.push(R1WeekList[i].ymd2)
        m_js.push(R1WeekList[i].m_js.toFixed(2))
        m_dt.push(R1WeekList[i].m_dt.toFixed(2))
        j_js.push(R1WeekList[i].j_js.toFixed(2))
        j_dt.push(R1WeekList[i].j_dt.toFixed(2))        
      }
      let max = Math.max(...m_js,...j_js)
      let min = Math.min(...m_js,...j_js)
      let series=[{
        name: '매매지수',
        type: 'line',
        data: m_js
      }, {
        name: '매매증감',
        type: 'column',
        data: m_dt
      },{
        name: '전세지수',
        type: 'line',
        data: j_js
      }, {
        name: '전세증감',
        type: 'column',
        data: j_dt
      }] 
      let chartOptions={
        colors: ['#0000FF','#0066FF', '#FF0000',  '#FF6600', '#FF9800'],
        tooltip: {
          x: {
            format: 'yyyy-MM-dd',
          }
        },
        chart: {
          height: 500,
          type: 'line',
        },
        stroke: {
          width: [5,0,5,0]
        },
        title: {
          text: sigun
        },
        dataLabels: {
          formatter: function (val, opts) {
              console.log(opts)
              return val
          },        
          // enabled: true,
          // enabledOnSeries: [1]
        },
        labels: Ymd2,
        xaxis: {
          labels: {
            format: 'yyyy/MM',
          },
          type: 'datetime',
          categories:Ymd2,
        },
        yaxis: [{
          seriesName:'매매지수',
          title: {
            text: '매매지수',
          },
          max: max,
          min: min        
        
        }, {
          opposite: true,
          seriesName:'매매증감',
          title: {
            text: '매매증감'
          },

        },{
          seriesName:'매매지수',
          title: {
            text: '전세지수',
          },
          max: max,
          min: min      
        }, {
          opposite: true,
          seriesName:'매매증감',
          title: {
            text: '전세증감'
          },

        }]
      }
      this.sigun = sigun
      this.date = Ymd2      
      // this.value2 = [this.date[0],this.date[30]]
      this.series = series
      this.chartOptions = chartOptions
      this.isLoading = false
      this.enableCross=false
      this.order=true
    },
    async getSidoList() {
        let SidoList = await this.$api("/api/SidoList",'post', {});
        this.SidoList = SidoList;

    },
    async getSigunList() {
        let SigunList = await this.$api("/api/SigunList",'post', {});

        this.SigunList = SigunList;
    }, 
    change_kb(a) {
      this.kb=a
      if(a=='kb'&&this.week=='week') {
        this.value2= [this.date_min_max.kb_week.min,this.date_min_max.kb_week.max]
      }
      if(a=='r1'&&this.week=='week') {
        this.value2= [this.date_min_max.r1_week.min,this.date_min_max.r1_week.max]
      }
      if(a=='kb'&&this.week=='mon') {
        this.value2= [this.date_min_max.kb_mon.min,this.date_min_max.kb_mon.max]
      }  
      if(a=='r1'&&this.week=='mon') {
        this.value2= [this.date_min_max.r1_mon.min,this.date_min_max.r1_mon.max]
      }    
    },
    change_week(a) {
      this.week=a
      if(a=='week'&&this.kb=='kb') {
        this.value2= [this.date_min_max.kb_week.min,this.date_min_max.kb_week.max]
      }
      if(a=='week'&&this.kb=='r1') {
        this.value2= [this.date_min_max.r1_week.min,this.date_min_max.r1_week.max]
      }
      if(a=='mon'&&this.kb=='kb') {
        this.value2= [this.date_min_max.kb_mon.min,this.date_min_max.kb_mon.max]
      }  
      if(a=='mon'&&this.kb=='r1') {
        this.value2= [this.date_min_max.r1_mon.min,this.date_min_max.r1_mon.max]
      }                 
    },     
  },
  
};

</script>

<style scoped>
.loading {
  z-index: 2;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: rgba(0, 0, 0, 0.1) 0 0 0 9999px;
}
</style>